import React, { useState } from "react";

import { HvInput } from "@hitachivantara/uikit-react-core";
import Context from "../Context";
import { ValueComponentProps } from "../types";

import { useStyles } from "./styles";

interface TextValueProps extends ValueComponentProps {
  value?: string;
}

const TextValue = ({
  id,
  value = "",
  initialTouched = false,
}: TextValueProps): JSX.Element => {
  const classes = useStyles();

  const context = React.useContext(Context);
  const { labels, dispatchAction } = context;

  const [touched, setTouched] = useState(initialTouched);

  const valid = value != null && value.toString().trim() !== "";

  return (
    <HvInput
      className={classes.location}
      label={labels.rule.value.text.label}
      required
      status={!touched ? "standBy" : valid ? "valid" : "invalid"}
      statusMessage={labels.rule.value.text.validation.required}
      value={value}
      inputProps={{
        autoComplete: "off",
      }}
      onChange={(t, v) => {
        dispatchAction({
          type: "set-value",
          id,
          value: v,
        });
      }}
      onBlur={() => {
        setTouched(true);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }}
      placeholder="—"
    />
  );
};

export default React.memo(TextValue);
